(() => {
  'use strict';
  if (window.MRSectionLayout) {
    window.MRSectionLayout.refresh();
    return;
  }
  function sectionFor(key, scope = document) {
    return Array.from(scope.querySelectorAll('.shopify-section')).find(section =>
      section.id === `shopify-section-${key}` || section.id.endsWith(`__${key}`)
    );
  }
  function clearContinuation(owner) {
    document.querySelectorAll('[data-mr20-gallery-owner]').forEach(card => {
      if (card.dataset.mr20GalleryOwner === owner) card.remove();
    });
  }
  function refresh() {
    document.querySelectorAll('[data-mr20-shell]').forEach(shell => {
      const scope = shell.closest('main') || document;
      shell.querySelectorAll('[data-mr20-slot]').forEach(slot => {
        const source = sectionFor(slot.dataset.mr20Slot, scope);
        if (!source || source === slot || source.contains(shell)) return;
        source.dataset.mr20Slot = slot.dataset.mr20Slot;
        slot.replaceWith(source);
      });
      shell.querySelectorAll('script[type="text/mr20-script"]').forEach(original => {
        const script = document.createElement('script');
        for (const { name, value } of original.attributes) {
          if (name !== 'type' && name !== 'data-mr20-script-type') script.setAttribute(name, value);
        }
        if (original.dataset.mr20ScriptType) script.type = original.dataset.mr20ScriptType;
        if (script.src && !script.hasAttribute('async')) script.async = false;
        script.textContent = original.textContent;
        original.replaceWith(script);
      });
    });
    document.querySelectorAll('[data-mr20-continuation]').forEach(continuation => {
      if (continuation.dataset.mr20Mounted === 'true') return;
      const owner = continuation.closest('.shopify-section');
      const target = sectionFor(continuation.dataset.mr20Target);
      const container = target?.querySelector(continuation.dataset.mr20Container);
      if (!owner || !container) return;
      clearContinuation(owner.id);
      Array.from(continuation.children).forEach(card => {
        card.dataset.mr20GalleryOwner = owner.id;
        container.appendChild(card);
      });
      continuation.dataset.mr20Mounted = 'true';
    });
    window.MRPortfolioViewer?.refresh();
    window.MRLocationSidebar?.refresh();
  }
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', event => {
    clearContinuation(event.target.id);
    const shell = event.target.querySelector('[data-mr20-shell]');
    if (!shell) return;
    const parent = event.target.parentNode;
    shell.querySelectorAll('.shopify-section[data-mr20-slot]').forEach(section => {
      parent.insertBefore(section, event.target.nextSibling);
    });
  });
  window.MRSectionLayout = { refresh };
  refresh();
})();
